import { DatePicker, Card, Row, Col, Select } from "antd";
import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import moment from "moment";
import { TableComp } from "sz-react-utils";
import Request from "../../request";

const { RangePicker } = DatePicker
const { Option } = Select;

class CounsellorDailyReport extends React.Component {
    state = {
        time: {
            from: moment().startOf('day'),
            to: moment().endOf('day'),
        },
        counsellors: [],
        counsellorId: null,
        count: 0
    };


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }



    chooseRangerPicker = (date, dateString) => {
        // Check if date array is valid and has two dates
        if (!date || !date[0] || !date[1]) {
            return; // do nothing if no dates are selected
        }

        this.setState({
            time: {
                from: moment(date[0]).startOf('day'),
                to: moment(date[1]).endOf('day'),
            }
        }, () => { this.table.current.reload() });
    }


    onOk = value => {
        this.table.current.reload()
    }

    apiRequest = (params = {}) => {
        return new Promise(async (resolve) => {
            if (this.state.time) {
                params.time = this.state.time;
            }
            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId;
            }
            let response = await Request.getCounsellorDailyReport(params);
            this.setState({ counsellors: response.users, count: response.total });
            return resolve(response);
        })
    }


    render() {
        let { time, counsellors, count } = this.state;
        const columns = [
            {
                title: 'Sr.No',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Name',
                key: 'name',
            },
            {
                title: 'Counsellings',
                key: 'counsellings',
            },
            {
                title: 'Registrations',
                key: 'registrations'
            },
            {
                title: "Follow Ups",
                key: 'followups',
            },
            {
                title: 'Hot Leads',
                key: 'hotLeads',
            },
            {
                title: 'Dropped',
                key: 'dropped'
            }
        ];
        return (
            <PageHeaderWrapper title={`Counsellor Report - ${count}`}>
                <Card bordered={true}>
                    <Row>

                        <Col span={8}>
                            <h4>Filter by Date</h4>
                            <RangePicker
                                value={[time.from, time.to]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>

                        {counsellors && counsellors.length > 1 ? (
                            <Col span={8}>
                                <h4>Search By Counsellor</h4>
                                <Select
                                    showSearch={true}
                                    allowClear
                                    optionFilterProp="children"
                                    style={{
                                        width: 214,
                                        paddingRight: 16,
                                        paddingLeft: 9
                                    }}
                                    value={this.state.counsellorId ? this.state.counsellorId : undefined}
                                    placeholder="Select Counsellor"
                                    onChange={counsellorId => {
                                        this.setState(
                                            { counsellorId: counsellorId && counsellorId.toString() },
                                            () => {
                                                this.table.current.reload()
                                            }
                                        )
                                    }}
                                >
                                    {counsellors.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.name}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Col>
                        ) : null}
                    </Row>
                </Card>

                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
});

export default connect(mapStateToProps)(CounsellorDailyReport);
